export default __webpack_public_path__ + "static/media/vox-img-legacy-003.9b2d5592.jpg";